import { CardSettings, LeadCardType, CARD_TYPES } from 'cards/constants/CardTypes';

import { SETTINGS_BY_CARD_TYPE } from 'cards/constants/settingsByCardType';
import { URL_SLUG_BY_CARD_TYPE } from 'cards/constants/urlSlugByCardType';

export const getCardSettings = (cardType?: LeadCardType, isDigital?: boolean): CardSettings => {
  if (isDigital) {
    return {
      type: 'DIGITAL_SAVE_THE_DATE',
      urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.dstd as LeadCardType],
      label: 'Digital save the dates',
      hasFoil: false,
      hasLetterpress: false,
      hasMotifs: true,
      hasShapes: false,
      hasMultipleOrientations: false,
      hasThirdPartyDesigns: false,
      hasCustomPhoto: false,
      hasNoCustomPhoto: false,
      hasMagnet: false,
      isVowRenewal: false,
      isLead: true,
      showPdpFreeAddressingModule: false,
      freeAddressingText: null,
      freeAddressingImage: null,
      showPdpCtdBanner: true,
      showPdpCovidBanner: false,
      showReviewStepCtdBanner: true,
    };
  }
  if (cardType && SETTINGS_BY_CARD_TYPE[cardType]) {
    return SETTINGS_BY_CARD_TYPE[cardType];
  }
  // @ts-expect-error We should have a guard against cardType not being defined or define this function to return CardSettings or an empty object
  return {};
};
